function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({
        alignToLogo: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        maxWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Max width (px)"
        },
        tabWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Tab width (px)"
        },
        contentMarginTop: {
            type: FIELD_TYPES.TEXT,
            label: "Content margin top (px)"
        },
        tabContentMaxWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Tab content max width"
        },
        iconSize: {
            type: FIELD_TYPES.TEXT,
            label: "Icon size (px)"
        }
    }, SharedAdvancedFieldsConfig)
};
